import { useLocation } from 'react-router-dom';
import { slicePath } from '../utils';

export const useParentLocation = (levelsUp?: number) => {
  const { pathname } = useLocation();

  return slicePath(pathname, 0, levelsUp || -1);
};
